import React from 'react';
import { Body4, Headline2 } from '../../../common/typography';
import {
  ImgAddNew,
  ImgAddSection,
  ImgAddSectionSave,
  ImgModalInfo,
  ImgMyLQAList,
  ImgQuestionButtons,
  ImgQuestionList,
  ImgSaveAndPublish,
  InformationItem,
  InformationList,
  RomanItem,
  RomanList,
} from '../../../pages/MyAudit/MyAuditChecklist/MyAuditChecklist.styled';
import myLqaMenu from '../../../common/images/CreateNewChecklist/myLqaMenu.png';
import addNew from '../../../common/images/CreateNewChecklist/addNew.jpg';
import addSection from '../../../common/images/CreateNewChecklist/addSection.png';
import addSectionSave from '../../../common/images/CreateNewChecklist/addSectionSave.jpg';
import questionButtons from '../../../common/images/CreateNewChecklist/questionButtons.jpg';
import questionList from '../../../common/images/CreateNewChecklist/questionList.jpg';
import saveAndPublish from '../../../common/images/CreateNewChecklist/saveAndPublish.jpg';
import { Modal } from '../../../common/sharedComponents/Modal';

export interface IChecklistTutorialModal {
  isOpen: boolean;
  isFullModal: boolean;
  handleModalClose: () => void;
  isShowCloseIcon: boolean;
}

export function ChecklistTutorialModal ({
  isOpen,
  isFullModal,
  handleModalClose,
  isShowCloseIcon,
}: IChecklistTutorialModal) {
  return (
    <Modal
      isOpen={isOpen}
      isFullModal={isFullModal}
      handleModalClose={handleModalClose}
      isShowCloseIcon={isShowCloseIcon}
    >
      <Headline2>Create New Checklist</Headline2>
      <InformationList>
        <InformationItem>
          <Body4>In myLQA tab open the myAudit checklists</Body4>
        </InformationItem>
        <ImgMyLQAList>
          <ImgModalInfo src={myLqaMenu} />
        </ImgMyLQAList>
        <InformationItem>
          <Body4>Click on “+ Add new”</Body4>
        </InformationItem>
        <ImgAddNew>
          <ImgModalInfo src={addNew} />
        </ImgAddNew>
        <InformationItem>
          <Body4>
            On the Add Checklist page, complete the form with the relevant
            details.
            <RomanList>
              <RomanItem>Checklist Name is required</RomanItem>
              <RomanItem>
                You have the option to assign a specific department to the
                checklist in “Department Access,” which relates to the
                visibility of the audit.
              </RomanItem>
              <RomanItem>
                If possible, please include a good description.
              </RomanItem>
            </RomanList>
          </Body4>
        </InformationItem>
        <ImgAddSection>
          <ImgModalInfo src={addSection} />
        </ImgAddSection>
        <InformationItem>
          <Body4>
            After entering all the relevant information, click on “+ Update
            Checklist.”
          </Body4>
        </InformationItem>
        <InformationItem>
          <Body4>
            On the Edit Checklist page, we can add sections with multiple
            questions by clicking the “+ Add Section” button
          </Body4>
        </InformationItem>
        <ImgAddSectionSave>
          <ImgModalInfo src={addSectionSave} />
        </ImgAddSectionSave>
        <InformationItem>
          <Body4>Give the Section a name and click “Save Changes”</Body4>
        </InformationItem>
        <InformationItem>
          <Body4>
            Now you can click on the created section to add questions to it
          </Body4>
        </InformationItem>
        <InformationItem>
          <Body4>
            In your section, you can add some optional information, such as
            whether the outlet, meal period, or room number are included and the
            Date and Time
          </Body4>
        </InformationItem>
        <InformationItem>
          <Body4>
            To upload a list of questions, first download the correct format by
            clicking ‘Download Bulk Upload Format.’ Then, you can either upload
            your list by selecting ‘Upload Questions List’ or manually add
            questions by clicking ‘Add Questions
          </Body4>
        </InformationItem>
        <ImgQuestionButtons>
          <ImgModalInfo src={questionButtons} />
        </ImgQuestionButtons>
        <InformationItem>
          <Body4>
            Clicking on Add Questions will open a form where you can enter the
            question name, performance classification, and scoring type
            <RomanList>
              <RomanItem>
                In the field name (Standard), you can choose an existing
                question or create a new one.
              </RomanItem>
              <RomanItem>
                Performance classification and score type fields are required
              </RomanItem>
            </RomanList>
          </Body4>
        </InformationItem>
        <InformationItem>
          <Body4>After filled click in “Add Question”</Body4>
        </InformationItem>
        <ImgQuestionList>
          <ImgModalInfo src={questionList} />
        </ImgQuestionList>
        <InformationItem>
          <Body4>
            Once everything is configured to your preference, you can either
            click Save to publish it later or choose “Publish Checklist” to make
            it available immediately.
          </Body4>
        </InformationItem>
        <ImgSaveAndPublish>
          <ImgModalInfo src={saveAndPublish} />
        </ImgSaveAndPublish>
      </InformationList>
    </Modal>
  );
}
